(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Shop = factory());
}(this, (function () { 'use strict';

    let config = { secretKey: '', storeName: '' };
    function openShopWindow({ url, title, w, h }) {
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
        const width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : screen.width;
        const height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : screen.height;
        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft;
        const top = (height - h) / 2 / systemZoom + dualScreenTop;
        let shopWindow = window.open(url, title, `
        scrollbars=yes,
        width=${w},
        height=${h},
        top=${top},
        left=${left}
        `);
        shopWindow.focus();
        return shopWindow;
    }
    function index ({ secretKey, storeName }) {
        if (!secretKey || !storeName) {
            throw new Error('Requires a secret key and store name');
        }
        const subscribe = () => {
            const shopWindow = openShopWindow({
                url: `https://pay.myshopify.io/pay/subscribe_with_shop?hmac_sha256=${config.secretKey}&storeName=${storeName}`,
                title: 'Subscribe with Shop',
                w: 500,
                h: 600,
            });
            return new Promise((resolve, reject) => {
                window.addEventListener('message', onMessageReceive, false);
                function onMessageReceive(event) {
                    if (!event?.data?.email) {
                        return;
                    }
                    resolve(event.data);
                    clearInterval(timerId);
                    window.removeEventListener('message', onMessageReceive, false);
                    shopWindow?.close();
                }
                let timerId = setInterval(function () {
                    if (shopWindow?.closed) {
                        reject({
                            status: 'failed',
                            message: 'User closed popup',
                        });
                        clearInterval(timerId);
                        window.removeEventListener('message', onMessageReceive, false);
                    }
                }, 1000);
            });
        };
        return {
            subscribe,
        };
    }

    return index;

})));
